<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App',
    }
</script>
<style>
    .B2CList .listTitle .ivu-list-item-meta-title {
        font-size: 12px;
        font-weight: normal;
        margin-bottom:0;
    }

    .B2CList .ivu-list-item-action>li{
        font-size:12px;
    }

    .B2CList .ivu-list-vertical .ivu-list-item-meta {
        margin-bottom:0;
    }

    .B2CList .ivu-list-vertical .ivu-list-item-action{
        margin-top:5px;
    }

    .B2CList td.ivu-table-expanded-cell {
        padding:0 15px;
	}
	.ivu-drawer-close .ivu-icon-ios-close {
		width:30px;
		height:30px;
	}
</style>
